import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { Redirect } from "react-router";
import { BsThreeDots } from "react-icons/bs";
import { apiJson } from "../../../api/Api";
import Pagination from "react-paginate";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { toast } from "react-toastify";
import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem } from "rc-menu";
import "rc-dropdown/assets/index.css";
import { getDesktopImage } from "../../../utils/utils";

const TableList = (props) => {
  const [values, setValues] = useState("");

  useEffect(() => {
    setValues(props.List);
  }, [props.List]);

  const handlePageChange = (pageNumber) => {
    props.pageChange(pageNumber.selected + 1);
  };
  const [dropdown, setdropdown] = useState({
    value: false,
    id: -1,
  });
  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const [isEditClick, setisEditClick] = useState(false);
  const [isViewClick, setisViewClick] = useState(false);
  const [isDeleteClick, setisDeleteClick] = useState(false);
  useEffect(() => {
    setisDeleteClick(false);
  }, []);

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this service?")) {
      setisDeleteClick(false);
      apiJson.services.deleteService(dropdown.id).then((response) => {
        if (response.success) {
          setisDeleteClick(true);
        } else if (!response.status) {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
              ? response.errors
              : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
    }
  };

  const menuItems = [
    <MenuItem
      key="2"
      onClick={() => setisViewClick(true)}
      style={{ cursor: "pointer" }}
    >
      View
    </MenuItem>,
    <MenuItem
      key="4"
      onClick={() => setisEditClick(true)}
      style={{ cursor: "pointer" }}
    >
      Edit
    </MenuItem>,
    <MenuItem key="1" onClick={handleDelete} style={{ cursor: "pointer" }}>
      Delete
    </MenuItem>,
  ];
  const menu = (
    <Menu
      className="menu"
      style={{
        width: "100px",
        textAlign: "center",
      }}
    >
      {menuItems}
    </Menu>
  );

  return (
    <div className="table-responsive">
      <Table hover className="overflow-auto borderless">
        <thead style={{ borderBottom: "#F5F5F9" }}>
          <tr className="table-head">
            <td className="">Service Image</td>
            <td className="">Name</td>
            <td className="">Status</td>
            <td className="">Actions</td>
          </tr>
        </thead>
        <tbody>
          {values !== "" &&
            values.map((service) => {
              const id = service.id;

              return (
                <tr key={service.id}>
                  <td className="service-image">
                    {service?.featured_image_resized ||
                    service?.featured_image ? (
                      <img
                        src={getDesktopImage(
                          service?.featured_image_resized,
                          service?.featured_image
                        )}
                        style={{
                          width: "auto",
                          maxWidth: "80px",
                          height: "80px",
                        }}
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                  </td>
                  <td className="name-text">{service.name_en}</td>
                  <td>
                    <div className="status-text">{service.status}</div>
                  </td>
                  <td className="">
                    <div className="action-wrapper">
                      <Dropdown
                        className="dropdown-for-send"
                        overlay={menu}
                        overlayClassName="overlay-class"
                      >
                        <button>
                          <BsThreeDots
                            style={{ cursor: "pointer" }}
                            onMouseEnter={() =>
                              setdropdown({
                                value:
                                  id === dropdown.id ? !dropdown.value : true,
                                id: id,
                              })
                            }
                          />
                        </button>
                      </Dropdown>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {props.pagination?.total_pages && values.length > 0 && (
        <div
          className="d-flex justify-content-center mb-4 w-100"
          style={{ direction: "ltr" }}
        >
          <Pagination
            direction="ltr"
            previousLabel={<FaChevronLeft color="#404553" />}
            nextLabel={<FaChevronRight color="#404553" />}
            pageCount={props.pagination?.total_pages}
            onPageChange={handlePageChange}
            pageRangeDisplayed={2}
            containerClassName="pagination"
            forcePage={parseInt(props?.pagination?.page) - 1}
            pageClassName="ms-3 me-3 ps-3 pe-3 pt-2 pb-2"
            activeClassName={
              "ms-3 me-3 ps-1 pe-1 text-primary border border-primary font-weight-bold rounded bg-white"
            }
            nextClassName="bg-white ps-3 pe-3 pt-2 pb-2"
            previousClassName="bg-white ps-3 pe-3 pt-2 pb-2"
          />
        </div>
      )}
      {isEditClick ? (
        <Redirect
          push
          to={{
            pathname: `/vendor/service/${dropdown.id}/edit`,
            state: { name: "edit", id: dropdown.id },
          }}
        />
      ) : isViewClick ? (
        <Redirect
          push
          to={{
            pathname: `/vendor/service/${dropdown.id}`,
            state: { name: "view", id: dropdown.id },
          }}
        />
      ) : (
        isDeleteClick && (
          <Redirect
            push
            to={{
              pathname: "/vendor/service-catalog",
              state: { name: `delete${dropdown.id}` },
            }}
          />
        )
      )}
    </div>
  );
};

export default TableList;
